import { render, staticRenderFns } from "./UserOrderOutReceive.vue?vue&type=template&id=b7908b66&"
import script from "./UserOrderOutReceive.vue?vue&type=script&lang=js&"
export * from "./UserOrderOutReceive.vue?vue&type=script&lang=js&"
import style0 from "./UserOrderOutReceive.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports